import IdeyaTypography from '../../../../common/antd/ideya-typography.tsx'
import { useAppSelector } from '../../../../redux/hooks.ts'
import { selectThemeStyle } from '../../../../features/setting/setting.slice.ts'
import IndividualRanking from '@assets/icons/ranking/individual-ranking.svg'
import TopPnlRanking from '@assets/icons/ranking/top-pnl-ranking.svg'
import Row from 'antd/es/grid/row'
import Col from 'antd/es/grid/col'

interface OverallRankingChartProps {
  type: 'Individual' | 'Company'
  topPnl: number
  userPnl: number
}

export const OverallRankingChart: React.FC<OverallRankingChartProps> = ({
  type,
  topPnl,
  userPnl,
}) => {
  const themeStyle = useAppSelector(selectThemeStyle)
  return (
    <div>
      <IdeyaTypography.Text style={{ marginBottom: '4px' }}>
        {type} PnL Ranking (USD)
      </IdeyaTypography.Text>
      <div
        style={{
          display: 'flex',
          borderRadius: '4px',
          backgroundColor: themeStyle.colorFillQuaternary,
          padding: '0px 52px 8px 52px',
          justifyContent: 'center',
        }}
      >
        <Row gutter={[16, 16]} style={{ alignItems: 'end' }}>
          <Col span={12}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                marginTop: '12px',
              }}
            >
              <TopPnlRanking />
              <div
                style={{
                  height: '130px',
                  width: '52px',
                  backgroundColor: themeStyle.colorPrimaryBgHover,
                }}
              />
            </div>
          </Col>
          <Col span={12}>
            <Col span={12}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 2,
                }}
              >
                {type === 'Individual' ? (
                  <IndividualRanking />
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                    }}
                  >
                    <IndividualRanking />
                    <IndividualRanking />
                  </div>
                )}
                <div
                  style={{
                    height: '39px',
                    width: '52px',
                    backgroundColor: themeStyle.gold3,
                  }}
                />
              </div>
            </Col>
          </Col>
        </Row>
      </div>
      <div
        style={{
          borderRadius: '4px',
          backgroundColor: themeStyle.colorFillQuaternary,
          padding: '5px 10px 12px 10px',
          width: '100%',
        }}
      >
        <Row justify={'space-between'}>
          <Col style={{ display: 'flex', alignItems: 'center' }}>
            {/* Hide this dash, used for alignment */}
            <IdeyaTypography.Text
              style={{ color: themeStyle.colorBorderSecondary, width: 10 }}
            >
              -
            </IdeyaTypography.Text>
            <IdeyaTypography.Text
              style={{ color: themeStyle.colorPrimaryText, marginLeft: 2 }}
            >
              Top 1
            </IdeyaTypography.Text>
          </Col>
          <Col>
            <IdeyaTypography.Text
              style={{ color: themeStyle.colorPrimaryText }}
            >
              ${topPnl.toLocaleString()}
            </IdeyaTypography.Text>
          </Col>
        </Row>
        <Row justify={'space-between'}>
          <Col style={{ display: 'flex', alignItems: 'center' }}>
            <IdeyaTypography.Text style={{ width: 10 }}>-</IdeyaTypography.Text>
            <IdeyaTypography.Text
              style={{ color: themeStyle.colorSecondaryText, marginLeft: 2 }}
            >
              {type === 'Individual' ? 'My PnL' : 'My Co. PnL'}
            </IdeyaTypography.Text>
          </Col>
          <Col>
            <IdeyaTypography.Text
              style={{ color: themeStyle.colorSecondaryText }}
            >
              ${userPnl.toLocaleString()}
            </IdeyaTypography.Text>
          </Col>
        </Row>
        <Row
          style={{
            width: '100%',
            borderBottom: `1px solid ${themeStyle.colorBorder}`,
          }}
        />
        <Row justify={'end'}>
          <Col>
            <IdeyaTypography.Text
              style={{ color: themeStyle.colorTertiaryText }}
            >
              ${(topPnl - userPnl).toLocaleString()}
            </IdeyaTypography.Text>
          </Col>
        </Row>
      </div>
    </div>
  )
}
